import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "fmtRegions",
    standalone: true,
})
export class SharedRegionsPipe implements PipeTransform {
    readonly regionBenchmarkProvider = "nationalBenchmark";

    transform(providerLabel: string, regions?: string[] | null, provider?: string | null): string {
        if (!regions?.length || (provider != null && provider !== this.regionBenchmarkProvider)) {
            return providerLabel;
        }

        if (regions.length === 1) {
            return `${regions[0].toUpperCase()} ${providerLabel}`;
        }

        const regionsList = regions.map(region => region.toUpperCase()).join(", ");
        return `${providerLabel} ${regionsList}`;
    }
}
